export const INTERNAL_ADMIN = '.CONTROL_INTERNAL_ADMIN';
export const INTERNAL_DEVELOPER = '.CONTROL_INTERNAL_DEVELOPER';
export const INTERNAL_EDIT_MENU_TEXT_ONLY = '.CONTROL_INTERNAL_EDIT_MENU_TEXT_ONLY';
export const INTERNAL_REVIEWER = '.CONTROL_INTERNAL_REVIEWER';
export const INTERNAL_EDIT_PRODUCTION_ENDPOINTS = '.CONTROL_INTERNAL_EDIT_PRODUCTION_ENDPOINTS';
export const INTERNAL_EDIT_PRODUCTION_SECRETS = '.CONTROL_INTERNAL_EDIT_PRODUCTION_SECRETS';
export const INTERNAL_EDIT_PRODUCTION_ROUTES = '.CONTROL_INTERNAL_EDIT_PRODUCTION_ROUTES';
export const INTERNAL_VIEW_ONLY = '.CONTROL_INTERNAL_VIEW_ONLY';
export const INTERNAL_PRODUCTION_DEPLOY = '.CONTROL_INTERNAL_PRODUCTION_DEPLOY';
export const INTERNAL_EDIT_PRODUCTION_KEYWORDS = '.CONTROL_INTERNAL_EDIT_PRODUCTION_KEYWORDS';
export const INTERNAL_FLOW_ASSET_LIBRARY_ADMIN = '.CONTROL_INTERNAL_FLOW_ASSET_LIBRARY_ADMIN';

// All internal roles
export const INTERNAL_ALL_ROLES: Array<string> = [
  INTERNAL_ADMIN,
  INTERNAL_DEVELOPER,
  INTERNAL_EDIT_MENU_TEXT_ONLY,
  INTERNAL_REVIEWER,
  INTERNAL_EDIT_PRODUCTION_ENDPOINTS,
  INTERNAL_EDIT_PRODUCTION_ROUTES,
  INTERNAL_EDIT_PRODUCTION_SECRETS,
  INTERNAL_VIEW_ONLY,
  INTERNAL_PRODUCTION_DEPLOY,
  INTERNAL_FLOW_ASSET_LIBRARY_ADMIN,
];

// Internal roles allowed to edit flows in dev environment.
export const INTERNAL_EDIT_FLOWS_ROLES: Array<string> = [INTERNAL_ADMIN, INTERNAL_DEVELOPER];

// Internal roles allowed to edit flows in dev environment.
export const INTERNAL_EDIT_MENU_TEXT_ONLY_ROLES: Array<string> = [
  INTERNAL_ADMIN,
  INTERNAL_DEVELOPER,
  INTERNAL_EDIT_MENU_TEXT_ONLY,
];

// Internal roles allowed to edit flows in dev environment.
export const INTERNAL_REVIEWER_ROLES: Array<string> = [INTERNAL_ADMIN, INTERNAL_REVIEWER];

// Internal roles that are allowed to edit endpoints on dev and uat environments
export const INTERNAL_EDIT_ENDPOINTS_ROLES: Array<string> = [
  INTERNAL_ADMIN,
  INTERNAL_DEVELOPER,
  INTERNAL_EDIT_PRODUCTION_ENDPOINTS,
];

// Internal roles that are allowed to edit endpoints on production environments
export const INTERNAL_EDIT_PRODUCTION_ENDPOINTS_ROLES: Array<string> = [
  INTERNAL_ADMIN,
  INTERNAL_EDIT_PRODUCTION_ENDPOINTS,
];

// Internal roles that are allowed to edit routes on dev and uat environments
export const INTERNAL_EDIT_ROUTES_ROLES: Array<string> = [INTERNAL_ADMIN, INTERNAL_DEVELOPER];

// Internal roles that are allowed to edit routes on production environments
export const INTERNAL_EDIT_PRODUCTION_ROUTES_ROLES: Array<string> = [
  INTERNAL_ADMIN,
  INTERNAL_EDIT_PRODUCTION_ROUTES,
];

// Internal roles that are allowed to edit secrets on dev and uat environments
export const INTERNAL_EDIT_SECRETS_ROLES: Array<string> = [
  INTERNAL_ADMIN,
  INTERNAL_DEVELOPER,
  INTERNAL_EDIT_PRODUCTION_SECRETS,
];

// Internal roles that are allowed to edit secrets on production environments
export const INTERNAL_EDIT_PRODUCTION_SECRETS_ROLES: Array<string> = [
  INTERNAL_ADMIN,
  INTERNAL_EDIT_PRODUCTION_SECRETS,
];

// Internal roles that are allowed deploy to production.
export const INTERNAL_PRODUCTION_DEPLOY_ROLES: Array<string> = [
  INTERNAL_ADMIN,
  INTERNAL_PRODUCTION_DEPLOY,
];

// Internal roles that are allowed to edit keywords on dev and uat environments
export const INTERNAL_EDIT_KEYWORDS_ROLES: Array<string> = [
  INTERNAL_ADMIN,
  INTERNAL_DEVELOPER,
  INTERNAL_EDIT_PRODUCTION_KEYWORDS,
];

// Internal roles that are allowed to edit keywords on production environments
export const INTERNAL_EDIT_PRODUCTION_KEYWORDS_ROLES: Array<string> = [
  INTERNAL_ADMIN,
  INTERNAL_EDIT_PRODUCTION_KEYWORDS,
  INTERNAL_EDIT_PRODUCTION_ROUTES,
];

// Internal roles that are allowed upload, edit and rename assets on library
export const INTERNAL_MANAGE_ASSETS_ROLES: Array<string> = [
  INTERNAL_ADMIN,
  INTERNAL_FLOW_ASSET_LIBRARY_ADMIN,
];

//////////////////////////////////////////////////////////////

export const CLIENT_ADMIN = '.CONTROL_CLIENT_ADMIN';
export const CLIENT_DEVELOPER = '.CONTROL_CLIENT_EDIT_FULL_DEV';
export const CLIENT_EDIT_MENU_TEXT_ONLY = '.CONTROL_CLIENT_EDIT_MENU_TEXT_ONLY';
export const CLIENT_REVIEWER = '.CONTROL_CLIENT_REVIEWER';
export const CLIENT_EDIT_PRODUCTION_ENDPOINTS = '.CONTROL_CLIENT_EDIT_PRODUCTION_ENDPOINTS';
export const CLIENT_EDIT_PRODUCTION_SECRETS = '.CONTROL_CLIENT_EDIT_PRODUCTION_SECRETS';
export const CLIENT_EDIT_PRODUCTION_ROUTES = '.CONTROL_CLIENT_EDIT_PRODUCTION_ROUTES';
export const CLIENT_VIEW_ONLY = '.CONTROL_CLIENT_VIEW_ONLY';
export const CLIENT_PRODUCTION_DEPLOY = '.CONTROL_CLIENT_PRODUCTION_DEPLOY';
export const CLIENT_EDIT_PRODUCTION_KEYWORDS = '.CONTROL_CLIENT_EDIT_PRODUCTION_KEYWORDS';
export const CLIENT_FLOW_ASSET_LIBRARY_ADMIN = '.CONTROL_CLIENT_FLOW_ASSET_LIBRARY_ADMIN';

// All client roles
export const CLIENT_ALL_ROLES: Array<string> = [
  CLIENT_ADMIN,
  CLIENT_DEVELOPER,
  CLIENT_EDIT_MENU_TEXT_ONLY,
  CLIENT_REVIEWER,
  CLIENT_EDIT_PRODUCTION_ENDPOINTS,
  CLIENT_EDIT_PRODUCTION_ROUTES,
  CLIENT_EDIT_PRODUCTION_SECRETS,
  CLIENT_VIEW_ONLY,
  CLIENT_PRODUCTION_DEPLOY,
  CLIENT_FLOW_ASSET_LIBRARY_ADMIN,
];

// Client roles allowed to edit flows in dev environment.
export const CLIENT_EDIT_FLOWS_ROLES: Array<string> = [CLIENT_ADMIN, CLIENT_DEVELOPER];

// Client roles allowed to edit flows in dev environment.
export const CLIENT_EDIT_MENU_TEXT_ONLY_ROLES: Array<string> = [
  CLIENT_ADMIN,
  CLIENT_DEVELOPER,
  CLIENT_EDIT_MENU_TEXT_ONLY,
];

// Client roles allowed to edit flows in dev environment.
export const CLIENT_REVIEWER_ROLES: Array<string> = [CLIENT_ADMIN, CLIENT_REVIEWER];

// Client roles that are allowed to edit endpoints on dev and uat environments
export const CLIENT_EDIT_ENDPOINTS_ROLES: Array<string> = [CLIENT_EDIT_PRODUCTION_ENDPOINTS];

// Client roles that are allowed to edit endpoints on production environments
export const CLIENT_EDIT_PRODUCTION_ENDPOINTS_ROLES: Array<string> = [
  CLIENT_EDIT_PRODUCTION_ENDPOINTS,
];

// Client roles that are allowed to edit routes on dev and uat environments
export const CLIENT_EDIT_ROUTES_ROLES: Array<string> = [CLIENT_ADMIN, CLIENT_DEVELOPER];

// Client roles that are allowed to edit routes on production environments
export const CLIENT_EDIT_PRODUCTION_ROUTES_ROLES: Array<string> = [
  CLIENT_ADMIN,
  CLIENT_EDIT_PRODUCTION_ROUTES,
];

// Client roles that are allowed to edit secrets on dev and uat environments
export const CLIENT_EDIT_SECRETS_ROLES: Array<string> = [
  CLIENT_ADMIN,
  CLIENT_DEVELOPER,
  CLIENT_EDIT_PRODUCTION_SECRETS,
];

// Client roles that are allowed to edit secrets on production environments
export const CLIENT_EDIT_PRODUCTION_SECRETS_ROLES: Array<string> = [
  CLIENT_ADMIN,
  CLIENT_EDIT_PRODUCTION_SECRETS,
];

// Client roles that are allowed deploy to production.
export const CLIENT_PRODUCTION_DEPLOY_ROLES: Array<string> = [
  CLIENT_ADMIN,
  CLIENT_PRODUCTION_DEPLOY,
];

// Client roles that are allowed to edit keywords on dev and uat environments
export const CLIENT_EDIT_KEYWORDS_ROLES: Array<string> = [
  CLIENT_ADMIN,
  CLIENT_DEVELOPER,
  CLIENT_EDIT_PRODUCTION_KEYWORDS,
];

// Client roles that are allowed to edit keywords on production environments
export const CLIENT_EDIT_PRODUCTION_KEYWORDS_ROLES: Array<string> = [
  CLIENT_ADMIN,
  CLIENT_EDIT_PRODUCTION_KEYWORDS,
  CLIENT_EDIT_PRODUCTION_ROUTES,
];
// Client roles that are allowed upload, edit and rename assets on library
export const CLIENT_MANAGE_ASSETS_ROLES: Array<string> = [
  CLIENT_ADMIN,
  CLIENT_FLOW_ASSET_LIBRARY_ADMIN,
];
